(function () {
  if (typeof window === 'undefined') return;

  function findGoals() {
    return document.querySelectorAll('[data-cart-goal]');
  }

  function update(totalCents, itemCount) {
    var bars = findGoals();
    if (!bars.length) return;

    bars.forEach(function (bar) {
      var threshold = parseInt(bar.dataset.goalThresholdCents, 10) || 0;
      if (threshold <= 0) return;

      var fill = bar.querySelector('[data-cart-goal-fill]');
      var copy = bar.querySelector('[data-cart-goal-copy]');
      var percent = Math.min(100, Math.round((totalCents / threshold) * 100));
      if (fill) fill.style.width = percent + '%';

      if (totalCents >= threshold) {
        bar.classList.add('cart-goal--met');
        if (copy && bar.dataset.copyMet) copy.innerHTML = bar.dataset.copyMet;
      } else {
        bar.classList.remove('cart-goal--met');
        if (copy && bar.dataset.copyRemaining) {
          var remaining = formatMoney(threshold - totalCents);
          copy.innerHTML = bar.dataset.copyRemaining.replace('__AMOUNT__', remaining);
        }
      }
    });

    updateShippingRow(totalCents, itemCount);
    scheduleSavings();
  }

  var savingsTimer = null;
  function scheduleSavings() {
    clearTimeout(savingsTimer);
    savingsTimer = setTimeout(syncSavings, 400);
  }

  function updateShippingRow(totalCents, itemCount) {
    document.querySelectorAll('[data-cart-shipping-status]').forEach(function (status) {
      var threshold = parseInt(status.dataset.thresholdCents, 10) || 0;
      if (threshold <= 0) return;

      if (totalCents >= threshold) {
        status.innerHTML = '<span class="cart__shipping-status--met">' + (status.dataset.copyFree || '') + '</span>';
      } else if (itemCount > 0) {
        var remaining = formatMoney(threshold - totalCents);
        status.innerHTML = (status.dataset.copyRemaining || '').replace('__AMOUNT__', remaining);
      } else {
        status.innerHTML = status.dataset.copyEmpty || '';
      }
    });
  }

  function formatMoney(cents) {
    if (window.theme && window.theme.Currency && window.theme.settings) {
      return window.theme.Currency.formatMoney(cents, window.theme.settings.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  function fetchAndUpdate() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { update(cart.total_price, cart.item_count); })
      .catch(function () {});
  }

  // The goal is measured after discounts, which can be applied a moment after the cart change: re-check once.
  var recheckTimer = null;
  function refresh() {
    fetchAndUpdate();
    clearTimeout(recheckTimer);
    recheckTimer = setTimeout(fetchAndUpdate, 800);
  }

  // "Din samlede rabat" is rendered by Liquid only, so it kept the old value after a quantity change.
  // Copy the freshly rendered row from the cart page (same calculation), hide it when there is no saving left,
  // and add it when the first saving appears.
  var savingsRequestId = 0;
  function syncSavings() {
    var requestId = ++savingsRequestId;
    fetch('/cart?x=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (requestId !== savingsRequestId) return; // a newer cart change superseded this response
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var src = doc.querySelector('.cart__savings-row');
        var srcAmount = src && src.querySelector('.cart__savings-amount');
        document.querySelectorAll('[data-subtotal]').forEach(function (sub) {
          var subRow = sub.closest('.cart__item-row');
          if (!subRow) return;
          var prev = subRow.previousElementSibling;
          var row = prev && prev.classList.contains('cart__savings-row') ? prev : null;
          if (!src || !srcAmount) {
            if (row) row.style.display = 'none';
            return;
          }
          if (!row) {
            row = src.cloneNode(true);
            subRow.parentNode.insertBefore(row, subRow);
          }
          var amount = row.querySelector('.cart__savings-amount');
          if (amount) amount.textContent = srcAmount.textContent.trim();
          row.style.display = '';
        });
      })
      .catch(function () {});
  }

  function init() {
    if (!findGoals().length) return;

    var subtotal = document.querySelector('#CartDrawer [data-subtotal]');
    if (subtotal) {
      new MutationObserver(refresh).observe(subtotal, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }

    document.addEventListener('ajaxProduct:added', refresh);
    document.addEventListener('cart:updated', function (evt) {
      var cart = evt && evt.detail && evt.detail.cart;
      if (cart && typeof cart.total_price === 'number') {
        update(cart.total_price, cart.item_count);
      } else {
        refresh();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
